/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Mentions_Group_ArtifactsInputs */



/**
* | output |
* | --- |
* | "Artifacts" |
*
* @param {Chat_Mentions_Group_ArtifactsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_mentions_group_artifacts = /** @type {((inputs?: Chat_Mentions_Group_ArtifactsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Mentions_Group_ArtifactsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Artefakte")
	return /** @type {LocalizedString} */ ("Artifacts")
});